import { render, staticRenderFns } from "./MarketTourForm.vue?vue&type=template&id=92621160&scoped=true&"
import script from "./MarketTourForm.vue?vue&type=script&lang=js&"
export * from "./MarketTourForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92621160",
  null
  
)

export default component.exports